
import React from 'react';
import { Text, View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';

import { ValidateSpanishID } from 'helpers/dni';

export const Document = ({ dni, setDni, isValidDNI, setIsValidDNI, invalidDNIreason }) => {
	return (
		<>
			<View inputFreeRowSt>
				<InputLabel
					// style={{ marginTop: -20 }}
					value={dni}
					onBlur={() => {
						setIsValidDNI(ValidateSpanishID(dni).valid);
					}}
					onChange={(e) => {
						if (!isValidDNI) {
							setIsValidDNI(ValidateSpanishID(e.target.value).valid);
						}
						setDni(e.target.value?.toUpperCase());
					}}
					errorMsg={!isValidDNI && invalidDNIreason}
					label={'DNI/NIE'}
				/>
			</View>
			<Text labelInputSt smSt style={{ marginTop: 10, marginBottom: 10 }}>
				Pedimos este dato para poder darte una oferta personalizada
			</Text>
		</>
	);
};
